import React from 'react'
import {Link} from 'gatsby'
import logo from "../../assets/images/amamfooter.png"
import footerMap from "../../assets/images/footer-map.png"
import {appVersion} from '../../app.version';

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-area bg-color">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <a href="/" className="logo">
                                <img src={logo} alt="logo" />
                            </a>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget pl-5">
                            <h3>Asociación Mexicana de Autoridades de Movilidad</h3>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Dirección</h3>

                            <ul className="footer-contact-info">
                                <li>
                                    <i className='bx bx-map'></i>
                                    Belisario Domínguez #8 P.A. <br />
                                    Col. Villa Coyoacán México, CDMX 04000
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:+44587154756">+52(55)30965742 al 45 ext. 309</a>
                                </li>
                                <li>
                                    <i className='bx bx-envelope'></i>
                                    <a href="mailto:hello@rewy.com">amam@newsletters.com</a>
                                </li>
                            </ul>
                            <ul className="social-link">
                                <li>
                                    <Link to="https://twitter.com/autoridades_mov" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-twitter'></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.facebook.com/AutoridadesMovilidad/" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-facebook'></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom-area">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <p>Copyright {currentYear} <strong>AMAM</strong></p>
                        </div>
                        <div className="col-lg-1 col-md-1 offset-5" style={{'font-size': 'small', 'color': 'lightgrey'}}>v{appVersion}</div>
                        {/* <div className="col-lg-1 col-md-1 offset-5" style={{'font-size': 'small', 'color': 'lightgrey'}}>v{`${process.env.GATSBY_APP_VERSION}`}</div> */}
                    </div>
                </div>
            </div>

            <div className="footer-map">
                <img src={footerMap} alt="footer-logo" />
            </div>
        </footer>
    );
}

export default Footer;
